import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
export const Container = ({ children, ...props }) => {
    const { noPaddingMobile, noPaddingTablet, noContainerTablet, ...restProps } = props;
    return (_jsx(Box, { paddingHorizontal: {
            'breakpoint.base': noPaddingMobile ? 'spacing.none' : 'spacing.16',
            'breakpoint.md': noPaddingTablet ? 'spacing.none' : 'spacing.16',
            'breakpoint.xl': 'spacing.16',
        }, children: _jsx(Box, { as: "div", maxWidth: {
                'breakpoint.base': '100%',
                'breakpoint.md': noContainerTablet ? '100%' : '524px',
                'breakpoint.lg': '1280px',
            }, width: "100%", marginHorizontal: "auto", ...restProps, children: children }) }));
};
